import { IAuthServiceV2 } from '@volkswagen-onehub/authservice';
import { Recall } from '../../models/Vehicle';
import { TechnicalData } from '../../models/TechnicalData';
import { makeVehicleApiRequest } from '../MakeVehicleApiRequestService/MakeVehicleApiRequestService';

export async function getAdditionalVehicleDetails(
	authService: IAuthServiceV2,
	resourceHostId: string,
	vin: string,
	technicalDetails: TechnicalData,
	language: string,
	url: string,
	apiKey: string,
	vinToken?: string,
): Promise<TechnicalData> {
	return makeVehicleApiRequest<TechnicalData>({
		authService,
		resourceHostId,
		url,
		endpoint: 'api/additionalVehicleData',
		apiKey,
		vinToken,
		fallbackValue: technicalDetails,
		body: {
			vin,
			languageCode: language,
		},
	});
}

export async function getRecalls(
	authService: IAuthServiceV2,
	resourceHostId: string,
	vin: string,
	productBrand: string,
	language: string,
	url: string,
	bid: string,
	countryCode: string,
	apiKey: string,
	vinToken?: string,
): Promise<Recall[]> {
	return makeVehicleApiRequest<Recall[]>({
		authService,
		resourceHostId,
		url,
		endpoint: 'api/recallsData',
		apiKey,
		vinToken,
		fallbackValue: [],
		body: {
			vin,
			languageCode: language,
			countryCode,
			bid,
			productBrand,
		},
	});
}
